import styles from "../../styles/Components/new-dashboard/DashboardContentBox.module.css";

function DashboardContentBox({
  children,
  style = {},
  className = "",
  onClick,
}) {
  const clickHandler = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div
      className={`${styles.container} ${className}`}
      style={{ ...style }}
      onClick={clickHandler}
    >
      {children}
    </div>
  );
}

export default DashboardContentBox;
